module.exports = __webpack_public_path__ + "static/alameda-dark-6e92d5c2cbe5b1c8ea19c6d407f5f92e.svg";